module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-4.cd06531a.png";